module.exports = __webpack_public_path__ + "static/media/sonMOBILE.fc034d7e.mp4";